/* @ngInject */
const myCancelValidateButtons = (
  valueHandler
) => {
  return {
    restrict: 'E',
    scope: {
      myLabel: '=?',
      myIcon: '=?',
      myClick: '&?',
      myDisabled: '=?',
    },
    template: require('./myCancelValidateButtons.html'),

    /* @ngInject */
    controller: ($scope, labels, icons) => {
      $scope.label = labels.validate
      $scope.icon = icons.validate
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myCancelValidateButtons



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/buttons/myCancelValidateButtons.js